import { render, staticRenderFns } from "./GetProfile.vue?vue&type=template&id=c0dee77e"
import script from "./GetProfile.vue?vue&type=script&lang=js"
export * from "./GetProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports